<template  minapp='mpx' xlang='wxml'>
  <view class="error">
    <image
      class="error-img"
      src="https://pt-starimg.didistatic.com/static/starimg/img/e3fgOAxwky1653462896827.png"
    />
    <text class="error-text" wx:for="{{errorMsg}}">{{ item }}</text>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {
      errorMsg: {
        type: Array,
        value: []
      }
    },
    data: {}
  })
</script>

<style lang='stylus' scoped>
  .error
    display flex
    flex-direction column
    align-items center
    background-color #F3F4F5
  .error-img
    margin-top 120px
    margin-bottom 17px
    width 100px
    height 100px
  .error-text
    font-weight 400
    font-size 14px
    color #333333
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
